import React from 'react';

import IconBtn from '../../../modules/icon-btn/icon-btn';
import TableFooterWrapper from '../../../modules/table-footer-wrapper/table-footer-wrapper';
import getWordDecl from '../../../utils/getWordDecl';

import UcpIcon from './ucp-btn.svg';

import './order-detailed-action.scss';

interface OrderDetailedActionProps {
  count: number;
  picked: number;
  sum: string;
  total: number;
  onSubmit: () => void;
  isInitiator: boolean;
  isError?: boolean;
  errorText?: string;
}

enum OrderDetailedActionStrings {
  INITIATOR_BTN = 'Создать решение о выпуске гибридного токена',
  RECIPIENT_BTN = 'Перейти к согласованию',
}

const OrderDetailedAction: React.FC<OrderDetailedActionProps> = ({
  count,
  isInitiator,
  onSubmit,
  sum,
  picked,
  isError,
  errorText,
}) => {
  const getDescString = () => {
    if (isError) {
      return <div className="table-footer__notice">{errorText}</div>;
    }

    return (
      <span>
        Выбрано: {count}{' '}
        {getWordDecl(count, ['реализация', 'реализации', 'реализаций'])} c{' '}
        {picked} {getWordDecl(picked, ['позицией', 'позициями', 'позициями'])}{' '}
        на сумму:
      </span>
    );
  };

  const getErrorDesc = () => (
    <div className="table-footer__desc">
      {`${picked} ${getWordDecl(picked, [
        'реализация',
        'реализации',
        'реализаций',
      ])} на сумму:`}
    </div>
  );

  return (
    <TableFooterWrapper
      right={
        <>
          <span>{getDescString()}</span>
          {isError && <div className="table-footer__notice-divider">|</div>}
          {isError && <span>{getErrorDesc()}</span>}
          <div className="table-footer__sum">
            {sum} <span>₽</span>
          </div>
          <div>
            <IconBtn
              disabled={isError}
              onClick={onSubmit}
              sm
              title={
                isInitiator
                  ? OrderDetailedActionStrings.INITIATOR_BTN
                  : OrderDetailedActionStrings.RECIPIENT_BTN
              }
              icon={UcpIcon}
            />
          </div>
        </>
      }
    />
  );
};
export default OrderDetailedAction;
